<div class="graph-container">
  @if (!loading) {
    @if (hasWorkHistoryItems) {
      @if (showPreviousWeek) {
        <c-button type="secondary" size="small" [iconOnly]="true" [icon]="leftIcon" (action)="setPreviousWeek()" />
      }
    }
    <div class="content-container">
      @if (hasWorkHistoryItems) {
        <div
          class="dashboard-items"
          #dashboardChart
          (scroll)="onScroll()"
          >
          @for (historyItem of visibleHistoryItems; track historyItem) {
            <div #chartColumns class="dashboard-item">
              @if (hasWorkHistoryItems) {
                <div class="dashboard-item1" (click)="viewWeekDetails(historyItem)">
                  <div #labels class="dashboard-item-top-label">
                    {{ historyItem.workedHours }}
                  </div>
                  <div
                    #bars
                    class="dashboard-item-bar"
                    [ngClass]="historyItem.isApproved ? 'item-approved' : 'item-not-approved'">
                    <div class="icons-container" #icons>
                      @if (historyItem.isApproved) {
                        <c-icon [icon]="faCheck" />
                      }
                      @if (!historyItem.isApproved) {
                        <c-icon [icon]="faHourglass" />
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="dashboard-item-bottom-label">
                {{ 'common.week-abbreviation' | transloco }}{{ historyItem?.weekNumber }}
              </div>
            </div>
          }
        </div>
      } @else {
        <ion-text class="center-container no-work-history">{{ 'my-work.no-work-history' | transloco }}</ion-text>
      }
    </div>
    @if (hasWorkHistoryItems) {
      @if (showNextWeek) {
        <c-button type="secondary" size="small" [iconOnly]="true" [icon]="rightIcon" (action)="setNextWeek()" />
      }
    }
  } @else {
    <div class="center-container">
      <c-spinner [loading]="true"></c-spinner>
    </div>
  }
</div>


